import Component from '../core/Component'

export const STATES = {
    ACTIVE: 'is-active'
}

export default class Aside extends Component {

    constructor(element) {
        super(element)

        this.ref = {
            toggle: null
        }
    }

    prepare() {
        this.ref.toggle.addEventListener('click', ::this.handleClick)
    }


    handleClick(event) {
        event.preventDefault()
        this.toggle()
    }

    toggle() {
        this.element.classList.toggle(STATES.ACTIVE)
    }

    open() {
        this.element.classList.add(STATES.ACTIVE)
    }

    close() {
        this.element.classList.remove(STATES.ACTIVE)
    }

}